import PlatformActions from './PlatformActions'

export default class JJEGAMEActions extends PlatformActions {
  constructor(formData) {
    super(formData)
    this.formData = formData

    this.constantTxnData = {
      gameType: 'EGAME',
      gameCode: '2J-EGAME-002',
      platform: 'JJ',
    }

    this.gameName = 'MINES'
  }

  getBetMessage(txnList) {
    const { currency, supportPremium } = this.formData

    const txns = txnList.map(({
      userId,
      txnId,
      betTime,
      betAmount,
    }) => ({
      ...this.constantTxnData,
      gameName: this.gameName,
      userId,
      platformTxId: `6001-0-1495-${txnId}`, // 6001-0-1495-1759288119
      roundId: `6001-0-1495-${txnId}`, // 6001-0-1495-1759288119
      betType: null,
      currency,
      betTime, // 2025-10-01T11:08:48.000+08:00
      betAmount,
      jackpotBetAmount: 0,
      gameInfo: {},
      ...(supportPremium && { isPremium: false }),
    }))

    const message = {
      action: 'bet',
      txns,
    }

    return JSON.stringify(message)
  }

  getSettleMessage(txnList) {
    const txns = txnList.map(({
      userId,
      txnId,
      updateTime,
      betTime,
      turnover,
      betAmount,
      winAmount,
    }) => ({
      ...this.constantTxnData,
      gameName: this.gameName,
      userId,
      platformTxId: `6001-0-1495-${txnId}`, // 6001-0-1495-1759288119
      refPlatformTxI: null,
      settleType: 'platformTxId',
      updateTime, // 2025-10-01T11:08:58.966+08:00
      roundId: `6001-0-1495-${txnId}`, // 6001-0-1495-1759288119
      betType: null,
      betTime, // 2025-10-01T11:08:48.000+08:00
      txTime: betTime,
      turnover,
      betAmount,
      winAmount,
      jackpotWinAmount: 0,
      gameInfo: {},
    }))

    const message = {
      action: 'settle',
      txns,
    }

    return JSON.stringify(message)
  }

  getCancelBetMessage(txnList) {
    const txns = txnList.map(({
      userId,
      txnId,
    }) => ({
      ...this.constantTxnData,
      userId,
      platformTxId: `6001-0-1495-${txnId}`, // 6001-0-1495-1759288119
      roundId: `6001-0-1495-${txnId}`, // 6001-0-1495-1759288119
      gameInfo: {},
    }))

    const message = {
      action: 'cancelBet',
      txns,
    }

    return JSON.stringify(message)
  }
}
